module.exports = __webpack_public_path__ + "img/Fahrerseite_1T_C_Heckmotor.372401d4.jpg";